import React from "react";
import AddressFields from "./AddessFields";

export default function ({register, watch, errors, close, handleSave}) {

  return (
    <>
      <div className="card-body pt-3">
        <div className="row">
          <AddressFields {...{register, errors, watch}} />
        </div>
      </div>
      <div className="card-footer d-flex justify-content-between align-items-center">
        <button
          type="button"
          onClick={close}
          className="btn btn-danger btn-hover-scale btn-sm mr-3"
        >
          cancel
        </button>
        <button
          type="button"
          onClick={() => handleSave()}
          className="btn btn-primary btn-hover-scale btn-sm"
        >
          save
        </button>
      </div>
    </>
  );
}